import { render } from "./update_class_barcode.vue?vue&type=template&id=46a854d8&scoped=true"
import script from "./update_class_barcode.vue?vue&type=script&lang=js"
export * from "./update_class_barcode.vue?vue&type=script&lang=js"

import "./update_class_barcode.vue?vue&type=style&index=0&id=46a854d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a854d8"]])

export default __exports__